module.exports = __webpack_public_path__ + "static/telegram-b2fdb6dc0d4a180605131ffd50ab8dfc.svg";